import { populate } from '@sly/core/constants/populate';
import ReviewerIndexPage from 'sly/resourceCenter/pages/ReviewerIndex';
import { createApiClient } from 'sly/services/api';
import apiEndpoints from 'sly/services/api/endpoints';

export default ReviewerIndexPage;

export async function getServerSideProps() {
  const { api, store } = createApiClient(apiEndpoints);
  try {
    await Promise.all(
      [
        api.getReviewer.asAction({
          populate: populate.reviewers,
          'filters[status]': 'active',
          sort: 'order',
        }),
        api.getResourceCenterCommonInfo.asAction(),
        api.getTopicHeader.asAction(),
      ].map(store.dispatch)
    );
  } catch (e) {
    console.error(e);
    return {
      notFound: true,
    };
  }
  return {
    props: {
      initialApiState: store.getState(),
    },
  };
}
